module.exports = __webpack_public_path__ + "static/media/colorectal-surgery-icon@3x.fe97dad2.png";